<header class="cw-page-head">
  <div class="cw-breadcrumb-mobile">
    @if (breadcrumbItems().length > 0) {
    <nav class="cw-breadcrumb" [attr.aria-label]="title()">
      @for (item of breadcrumbItems(); track item.label) {
        @if ($index >= 1) {
          <span aria-hidden="true">/</span>
        }
        @if (item.link && item.link !== "") {
          <a [routerLink]="item.link" [queryParams]="item.queryParams">{{ item.label }}</a>
        }
        @else {
          <span aria-current="page">{{ item.label }}</span>
        }
      }
    </nav>
    }
    @if (upperSubtitle() !== "") {
    <p class="cw-page-head__subtitle">{{ upperSubtitle() }}</p>
    }
    @if (title() !== "") {
    <h1 class="cw-page-head__title" id="upgrade-title">
      {{ title() }}
    </h1>
    }
    @if (subtitle() !== "") {
    <p class="cw-page-head__subtitle">
      {{ subtitle() }}
    </p>
    }
  </div>
  <div class="cw-thinksafe cw-thinksafe-mobile">
    <img class="cw-thinksafe__logo" src="/assets/thinksafe-logo.png" alt="ThinkSafe" />
    <span class="cw-thinksafe__link">Browse Health &amp; Safety Documents</span>
  </div>
</header>